import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=45dcb3ce&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=javascript&"
export * from "./setting.vue?vue&type=script&lang=javascript&"
import style0 from "./setting.vue?vue&type=style&index=0&id=45dcb3ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dcb3ce",
  null
  
)

export default component.exports